module.exports = __webpack_public_path__ + "static/06-ba12d2666c7f1c6ceb2ea5a11b38355e.jpg";